import { useEffect, useState } from "react";
import RepFinReportHeader from "./rep-fin-report-header";
import RepFinReportTotal from "./rep-fin-report-total";
import dayjs from "dayjs";
import { serverFetch } from "../../../server";
import { strDate2Server } from "../../../extensions/utils";
import { message } from "antd";
import { isMobile } from "../../../extensions/design";
import { ExcelDataProvider } from "../rep-excel-data-provider";

const reportTypes = [
  { value: 0, label: 'Сводно' },
  { value: 1, label: 'По дням' },
  { value: 7, label: 'По неделям' },
  { value: 31, label: 'По месяцам' },
];

// Финансовый отчет, состоящий из шапки и общего отчета
const RepFin = () => {
  const [filters, setFilters] = useState({
    dateFrom: dayjs(),
    dateTo: dayjs(),
    cash: [],
    reportType: reportTypes[0].value,
  });

  const [loading, setLoading] = useState(false);
  const onFilterChange = (value) => {
    setFilters({...filters, ...value})}
  
  const [data, setData] = useState([]);

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const getData = () => {
    setLoading(true);
    serverFetch("report/finance", {method: "POST", bodyData: {...filters, dateFrom: strDate2Server(filters.dateFrom), dateTo: strDate2Server(filters.dateTo) }})
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

  useEffect(getData, []);

  useEffect(() => {
    if (isMobile) {
      getData();
    }
  }, [filters]);

  const onRefresh = () => {
    getData();
    setRefreshTrigger((prev) => prev + 1);
  };
  
  return (
    <ExcelDataProvider>
      <RepFinReportHeader filters={filters} onFilterChange={onFilterChange} reportTypes={reportTypes} onRefresh={onRefresh} loading={loading}/>
      <RepFinReportTotal filters={filters} loading={loading} data={data} onRefresh={getData} refreshTrigger={refreshTrigger}/>
    </ExcelDataProvider>
  )
}

export default RepFin;